import { extend } from 'vee-validate';
import * as builtInRules from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en';
import * as customRules from '@/validations';

export default function (rules) {
	for (const rule of rules) {
		if (rule.startsWith('custom_')) {
			extend(rule, customRules[rule]);
		} else if (rule === 'min_value') {
			// Custom message for min_value with comma formatting
			extend(rule, {
				...builtInRules[rule],
				message: (fieldName, placeholders) => {
					const formattedMin = Number(placeholders.min).toLocaleString('en-US');
					return `The ${fieldName} field must be ${formattedMin} or more`;
				}
			});
		} else if (rule === 'max_value') {
			// Custom message for max_value with comma formatting
			extend(rule, {
				...builtInRules[rule],
				message: (fieldName, placeholders) => {
					const formattedMax = Number(placeholders.max).toLocaleString('en-US');
					return `The ${fieldName} field must be ${formattedMax} or less`;
				}
			});
		} else {
			extend(rule, {
				...builtInRules[rule],
				message: en.messages[rule]
			});
		}
	}
}
